import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { FormControl, Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { updateCalibration } from '../../features/fueladmin/fuelSlice';
import { apiClient } from '../../utils/axiosAdvanced';
import { CircularProgress } from '@mui/material';


const FuelCalibrate = ({ fuelSetup, assetId, sensorIndex }) => {
    const dispatch = useDispatch();

    const [file, setFile] = useState();
    const { calibrationCode, sensorId } = fuelSetup.sensors[sensorIndex - 1];
    const [loading, setLoading] = useState(false)
    function handleChange(event) {
        setFile(event.target.files[0])
    }
    /*useEffect(() => {
        //console.log("Fuel setup", fuelSetup);
        //console.log("Sensor Index", sensorIndex);
        //console.log("BRand", fuelSetup.sensors[sensorIndex - 1].sensorBrand);
    }, [fuelSetup, sensorIndex])*/


    async function handleSubmit(event) {
        event.preventDefault();
        setLoading(true);
        let form = new FormData();
        form.append('imei', assetId);
        form.append('sensorIndex', sensorIndex);
        form.append('sensorId', sensorId);
        form.append('file', file);
        const apiData = await apiClient.post('/fuel_add_calibration', form);
        if (apiData.data.error) {
            setLoading(false);
            return apiData.data.error;
        } else {
            setLoading(false);
            dispatch(updateCalibration({ assetId, sensorIndex, calibrationCode: apiData.data.calibrationCode, sensorId: apiData.data.sensorId }));
        }

    }

    return (
        <div className="App">
            {
                loading ? <CircularProgress /> :
                    <div>
                        {
                            calibrationCode ?
                                <div>
                                    <Grid container spacing={1}>
                                        <Grid item xs={4}><Typography variant="body2">Brand: </Typography></Grid>
                                        <Grid item xs={8}><Typography variant="body1"> <span><em>{fuelSetup.sensors[sensorIndex - 1].sensorBrand}</em></span></Typography></Grid>
                                    </Grid>
                                    <Grid container spacing={1}>
                                        <Grid item xs={4}><Typography variant="body2">Neuron Serial: </Typography></Grid>
                                        <Grid item xs={8}><Typography variant="body1"><span><em>{fuelSetup.sensors[sensorIndex - 1].sensorSerial}</em></span></Typography></Grid>
                                    </Grid>
                                    <Grid container spacing={1}>
                                        <Grid item xs={4}><Typography variant="body2">Manufacturer Serial: </Typography></Grid>
                                        <Grid item xs={8}><Typography variant="body1"><span><em>{fuelSetup.sensors[sensorIndex - 1].manufacturerSerial}</em></span></Typography></Grid>
                                    </Grid>
                                    <Grid container spacing={1}>
                                        <Grid item xs={4}><Typography variant="body2">Mac Address: </Typography></Grid>
                                        <Grid item xs={8}><Typography variant="body1"><span><em>{fuelSetup.sensors[sensorIndex - 1].sensorMac}</em></span></Typography></Grid>
                                    </Grid>
                                    <Grid container spacing={1}>
                                        <Grid item xs={4}><Typography variant="body2">Sensor Param:</Typography></Grid>
                                        <Grid item xs={8}><Typography variant="body1"><span><em>{fuelSetup.sensors[sensorIndex - 1].sensorParam}</em></span></Typography></Grid>
                                    </Grid>
                                    <Grid container spacing={1}>
                                        <Grid item xs={4}><Typography variant="body2">Sensor Index: </Typography></Grid>
                                        <Grid item xs={8}><Typography variant="body1"><span><em>{fuelSetup.sensors[sensorIndex - 1].sensorIndex}</em></span></Typography></Grid>
                                    </Grid>
                                </div>
                                : null
                        }

                        <FormControl sx={{ m: 1, width: '70ch' }} >
                            <Typography color="text.primary" variant="subtitle1" gutterBottom align="center">
                                {calibrationCode ? <span><em>Calibration Available {calibrationCode}</em></span> : <span><em>No Calibration file</em></span>}
                            </Typography>
                            <Typography color="text.secondary" variant="subtitle1" gutterBottom align="center">
                                {file ? <span><em>File Selected</em></span> : <span><em>Select a File</em></span>}
                            </Typography>
                            <Button variant="contained" component="label" color="primary">
                                {" "}
                                Browse
                                <input
                                    type="file"
                                    name="calib"
                                    onChange={handleChange}
                                    hidden
                                />
                            </Button>

                            <Button onClick={handleSubmit} disabled={!file}>{`${calibrationCode ? 'Re' : ''}Upload`} Calibration
                            </Button>
                        </FormControl>
                    </div>


            }
        </div>
    );
}

export default FuelCalibrate;